import { render, staticRenderFns } from "./PaymentsReceivedRow.vue?vue&type=template&id=589009e2"
import script from "./PaymentsReceivedRow.vue?vue&type=script&lang=js"
export * from "./PaymentsReceivedRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports